import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { StatusUpdateScope } from "tekkr-common/dist/model/project/chat";

interface Input {
    projectId: string;
    chatId: string;
    scope: StatusUpdateScope;
    content: string;
}

interface Options {
    onSuccess?: (data: { id: string; sentAt: string }) => void;
}

export function useCreateProjectUpdateMutation(options?: Options) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (input: Input) => {
            const res = await apiClient.createProjectUpdate({
                params: { projectId: input.projectId },
                body: {
                    chatId: input.chatId,
                    scope: input.scope,
                    content: input.content,
                },
            });
            if (res.status !== 201) {
                throw new Error("Error creating project update");
            }
            return res.body;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ["project"] });
            options?.onSuccess?.(data);
        },
    });
}
